<Box
  bg={bg}
  align="center"
  vertical="top"
  py="4px" pl="0.75" pr="0.75"
  mr="2px" mb="2px"
  line="1"
  {rounded}
  >
  <Label 
    xs 
    color={color} 
    bold
    h="1.05" line="1"
    >
    <slot></slot>
  </Label>
</Box>

<script>
  import { createEventDispatcher } from 'svelte';
  import { Box, Icon, Panel, Label, Text } from 'svelte-stylo';
  
	const emit = createEventDispatcher();  

  export let 
    bg = 'info++',
    color = 'surface',
    label = '',
    rounded = '0px 12px 12px 12px';
</script>
